import React, {  } from 'react';

import { SbCurrentUser } from '../submission_boards/component/SbModel';
import SubmissionKitsPagev1 from './SubmissionKitsPagev1';
import SubmissionKitsPagev2 from './SubmissionKitsPagev2';
export interface SubmissionKitsPageProps {
  currentUser: SbCurrentUser;
}
export default function SubmissionKitsPage({ currentUser }: SubmissionKitsPageProps) {
  const version:number = 2;
   return (
     <>
       {version == 1 && (
         <>
           <SubmissionKitsPagev1 currentUser={currentUser} />
         </>
       )}
       {version == 2 && (
         <>
           <SubmissionKitsPagev2 currentUser={currentUser} />
         </>
       )}
     </>
   );
}
